import { faPlay } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import type { AbstractSubmitStepProps } from "@component/assets/AbstractLeadForm/Steps/AbstractSubmitStep";
import type { LeadFormStepFields } from "@component/assets/AbstractLeadForm/Steps/BasicLeadForm";
import { BasicLeadForm } from "@component/assets/AbstractLeadForm/Steps/BasicLeadForm";
import type { LeadRequest } from "@component/assets/AbstractLeadForm/types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormRadio, ProgressButton } from "bm-ui-kit";
import type { FormApi } from "final-form";
import type { ReactNode } from "react";
import React from "react";
import { Card } from "react-bootstrap";
import type { PensionGapLeadCalcRequest, PensionGapLeadCalcResponse } from "../../LeadForm/types";

export const REQUEST_CONSULTANT_CALL_OPTIONS = [
	{
		label: "A konkrét megoldási lehetőségek érdekelnek. Szeretném szakértő segítségét kérni, hogy egészíthetem ki a nyugdíjamat.",
		value: true,
	},
	{
		label: "Csak kíváncsiskodtam.",
		value: false,
	},
];

export interface StepFields {
	firstName: string;
	lastName: string;
	email: string;
	phone: string;
	cityName: string;
	cityId?: number;
	needConsultantCall: boolean;
}

interface Props extends AbstractSubmitStepProps {
	email: string;
	leadId: number;
	data: LeadRequest<PensionGapLeadCalcRequest, PensionGapLeadCalcResponse>;
}

export class LeadForm extends BasicLeadForm {
	props: Props;
	public static defaultProps = {
		...BasicLeadForm.defaultProps,
		title: <>Kérd részletes eredményeidet emailben!</>,
	};

	protected initValues(): StepFields {
		return {
			lastName: undefined,
			firstName: undefined,
			cityName: undefined,
			phone: undefined,
			email: undefined,
			cityId: undefined,
			needConsultantCall: undefined,
		};
	}

	protected renderContent(
		_values: StepFields,
		_form: FormApi<LeadFormStepFields, Partial<LeadFormStepFields>>,
	): ReactNode {
		const { submitState } = this.props;
		const disabled = this.isDisabled();

		return (
			<>
				{super.renderHeader()}
				<Card.Body className="bg-dark">
					{super.renderFields()}
					<FormRadio
						label=""
						name="needConsultantCall"
						className="text-white bg-dark rounded pt-2 mt-2"
						options={REQUEST_CONSULTANT_CALL_OPTIONS}
						disabled={disabled}
					/>
					{super.renderPrivacyStatement()}
				</Card.Body>
				<Card.Footer className="text-center">
					<ProgressButton
						type="primary"
						block
						icon={<FontAwesomeIcon icon={faPlay} />}
						state={submitState}
						className={`${!_form.getState().valid ? "disabled" : ""} text-uppercase font-weight-bold`}
					>
						Beküldöm
					</ProgressButton>
				</Card.Footer>
			</>
		);
	}

	protected getComponentName(): string {
		return `${super.getComponentName()}.LeadForm`;
	}
}
